export const FETCH_GROUP_CAMERAS = 'FETCH_GROUP_CAMERAS';
export const FETCH_PAIRABLE_CAMERAS = 'FETCH_PAIRABLE_CAMERAS';
export const FETCH_CAMERA_IMAGE = 'FETCH_CAMERA_IMAGE';
export const FETCH_CAMERA_VIDEO = 'FETCH_CAMERA_VIDEO';
export const PAIR_CAMERAS = 'PAIR_CAMERAS';
